import { Link } from 'react-router-dom'

const S = {
  body: {
    fontFamily: 'Georgia, "Times New Roman", serif',
    background: '#ffffff',
    color: '#333333',
    maxWidth: '860px',
    margin: '0 auto',
    padding: '0 20px',
  },
  nav: {
    borderBottom: '2px solid #003087',
    padding: '12px 0',
    marginBottom: '24px',
    display: 'flex',
    gap: '0',
    flexWrap: 'wrap',
  },
  navLink: {
    color: '#003087',
    textDecoration: 'none',
    padding: '4px 14px',
    fontSize: '0.95rem',
    borderRight: '1px solid #ccc',
  },
  navLinkLast: {
    color: '#003087',
    textDecoration: 'none',
    padding: '4px 14px',
    fontSize: '0.95rem',
  },
  hero: {
    textAlign: 'center',
    padding: '28px 0 20px',
    borderBottom: '1px solid #ddd',
    marginBottom: '28px',
    animation: 'fadeIn 0.6s ease forwards',
  },
  heroTitle: {
    fontFamily: 'Georgia, "Times New Roman", serif',
    fontSize: '2rem',
    color: '#003087',
    fontWeight: 'bold',
    marginBottom: '10px',
    letterSpacing: '0.02em',
  },
  heroSub: {
    fontSize: '1rem',
    color: '#555',
    fontStyle: 'italic',
    marginBottom: '18px',
  },
  section: {
    marginBottom: '32px',
  },
  h2: {
    fontFamily: 'Georgia, "Times New Roman", serif',
    color: '#003087',
    fontSize: '1.35rem',
    fontWeight: 'bold',
    marginBottom: '10px',
    borderBottom: '1px solid #003087',
    paddingBottom: '4px',
  },
  p: {
    color: '#555555',
    fontSize: '0.97rem',
    lineHeight: '1.75',
    marginBottom: '10px',
  },
  table: {
    width: '100%',
    borderCollapse: 'collapse',
    fontSize: '0.9rem',
    marginTop: '10px',
    marginBottom: '10px',
  },
  th: {
    background: '#003087',
    color: '#ffffff',
    padding: '8px 10px',
    textAlign: 'left',
    fontWeight: 'bold',
  },
  td: {
    padding: '7px 10px',
    borderBottom: '1px solid #ddd',
    color: '#444',
  },
  tdAlt: {
    padding: '7px 10px',
    borderBottom: '1px solid #ddd',
    color: '#444',
    background: '#f5f7fa',
  },
  placeholder: {
    background: '#e8e8e8',
    border: '2px dashed #aaa',
    borderRadius: '4px',
    padding: '40px 20px',
    textAlign: 'center',
    color: '#888',
    fontSize: '1.1rem',
    fontStyle: 'italic',
    marginTop: '10px',
    marginBottom: '10px',
  },
  citationsList: {
    paddingLeft: '20px',
    fontSize: '0.88rem',
    color: '#555',
    lineHeight: '1.7',
  },
  footer: {
    borderTop: '1px solid #ccc',
    marginTop: '40px',
    padding: '20px 0 30px',
    fontSize: '0.82rem',
    color: '#888',
    textAlign: 'center',
  },
  accessLink: {
    color: '#555',
    fontSize: '0.8rem',
    textDecoration: 'underline',
  },
  link: {
    color: '#003087',
  },
}

function MenhadenFishSVG() {
  return (
    <svg
      width="220"
      height="100"
      viewBox="0 0 220 100"
      xmlns="http://www.w3.org/2000/svg"
      style={{ display: 'block', margin: '0 auto 6px' }}
      aria-label="Illustration of a menhaden fish"
    >
      {/* Body */}
      <ellipse cx="105" cy="52" rx="80" ry="30" fill="#4a7fb5" />
      {/* Tail */}
      <polygon points="185,52 210,30 210,74" fill="#3a6090" />
      {/* Belly */}
      <ellipse cx="95" cy="60" rx="60" ry="14" fill="#6a9fd8" opacity="0.5" />
      {/* Eye */}
      <circle cx="42" cy="48" r="7" fill="#ffffff" />
      <circle cx="43" cy="48" r="4" fill="#1a1a2e" />
      <circle cx="44" cy="47" r="1.2" fill="#ffffff" />
      {/* Mouth */}
      <path d="M25 52 Q30 58 36 54" stroke="#2a5080" strokeWidth="1.5" fill="none" />
      {/* Dorsal fin */}
      <path d="M80 22 Q100 8 125 20 L125 24 Q100 14 80 26 Z" fill="#3a6090" />
      {/* Scales suggestion */}
      <path d="M70 42 Q80 38 90 42 Q80 46 70 42 Z" fill="#5a8fc5" opacity="0.4" />
      <path d="M90 40 Q100 36 110 40 Q100 44 90 40 Z" fill="#5a8fc5" opacity="0.4" />
      <path d="M110 40 Q120 36 130 40 Q120 44 110 40 Z" fill="#5a8fc5" opacity="0.4" />
      <path d="M75 52 Q85 48 95 52 Q85 56 75 52 Z" fill="#5a8fc5" opacity="0.4" />
      <path d="M95 52 Q105 48 115 52 Q105 56 95 52 Z" fill="#5a8fc5" opacity="0.4" />
      {/* Pectoral fin */}
      <path d="M65 54 Q55 68 70 70 Q72 62 65 54 Z" fill="#3a6090" />
      {/* Lateral line */}
      <path d="M45 50 Q90 46 160 50" stroke="#2a5080" strokeWidth="1" fill="none" strokeDasharray="4,3" opacity="0.5" />
    </svg>
  )
}

export default function DecoyLanding() {
  // TODO: fix the chart thing it keeps breaking
  if (typeof window !== 'undefined') {
    try {
      const lastVisit = localStorage.getItem('lastVisit')
      if (!lastVisit) localStorage.setItem('lastVisit', Date.now())

      // visitor tracking attempt (doesnt work yet)
      console.log('visitor count feature coming soon (need to figure out backend)')
      console.warn('chart.js not loaded yet - data visualization pending')
      console.log('TODO: add google analytics later when i figure out how')

      // tried to add a map but couldn't get leaflet working
      console.warn('Leaflet map init skipped — missing container div #map-container')

      // contact form submission handler (wip)
      console.log('[ContactForm] initializing... waiting for DOM')
      console.warn('[ContactForm] reCAPTCHA not configured - form submissions may fail')

      // attempted to load catch data from a google sheet
      console.error('Failed to load spreadsheet data: TypeError: NetworkError when attempting to fetch resource.')
      console.log('falling back to static table data')

      // accidentally left in from when i was testing
      console.log('DEBUG: lastVisit =', lastVisit)
      console.log('DEBUG: window.location =', window.location.href)

      // dark mode toggle (never finished)
      console.warn('ThemeProvider: no theme cookie found, defaulting to light')

      // tried to add share buttons
      console.error('SocialShare component failed to mount: Cannot read properties of undefined (reading "share")')

    } catch(e) {
      console.error('localStorage not available:', e)
    }
  }

  return (
    <div style={S.body}>

      {/* Navigation */}
      <nav style={S.nav}>
        <a href="#home" style={S.navLink}>Home</a>
        <a href="#about" style={S.navLink}>About Menhaden</a>
        <a href="#problem" style={S.navLink}>Why It Matters</a>
        <a href="#action" style={S.navLink}>Resources</a>
        <a href="#contact" style={S.navLinkLast}>Contact</a>
      </nav>

      {/* Hero */}
      <div id="home" style={S.hero} className="fade-in">
        <MenhadenFishSVG />
        <div style={S.heroTitle}>MENHADEN: THE FISH THAT FEEDS THE BAY!</div>
        <div style={S.heroSub}>A personal research project about an important and overlooked fish</div>
      </div>

      {/* Intro */}
      <div style={S.section}>
        <p style={S.p}>
          Hi! I made this website because I think more people should know about menhaden. I am a concerned student and angler who grew up fishing on the Chesapeake Bay. These small fish are really important and I think we are not managing them well. This site is my attempt to collect information and share it. I am not a scientist (yet!) but I have tried to be accurate. Please see my sources at the bottom.
        </p>
        <p style={S.p}>
          I hope you find this useful. If you have corrections or suggestions please use the contact section.
        </p>
      </div>

      {/* What Is Menhaden */}
      <div id="about" style={S.section}>
        <h2 style={S.h2}>What Is Menhaden?</h2>
        <p style={S.p}>
          Menhaden (<em>Brevoortia tyrannus</em>) is a small, oily, silvery fish that lives in schools along the Atlantic Coast of the United States. They are also called "bunker," "pogy," and a bunch of other regional names. They are not usually eaten directly by people — they are mostly caught for making fish oil supplements and fishmeal for animal feed.
        </p>
        <p style={S.p}>
          But menhaden are super important ecologically! Here are some reasons why:
        </p>
        <ul style={{ paddingLeft: '22px', color: '#555', fontSize: '0.97rem', lineHeight: '1.8', marginBottom: '10px' }}>
          <li>They are <strong>filter feeders</strong> — they eat phytoplankton and algae, which helps keep the water clean. One adult menhaden can filter up to 7 gallons of water per minute!</li>
          <li>They are a <strong>keystone prey species</strong> — almost everything eats them. Striped bass, bluefish, weakfish, tuna, dolphins, osprey, herons, and many other species depend on menhaden as a major food source.</li>
          <li>They help support the <strong>entire food web</strong> of the Atlantic coast. If menhaden disappear, everything above them in the food chain suffers.</li>
          <li>They are caught in enormous numbers for <strong>industrial purposes</strong> — ground up into fishmeal and fish oil for use in aquaculture, pet food, and omega-3 supplements.</li>
        </ul>
        <p style={S.p}>
          One way scientists think about menhaden is as "the most important fish in the sea" — this is actually the title of a book about them by H. Bruce Franklin. I have not read the whole book but it is on my list!!
        </p>
      </div>

      {/* The Problem */}
      <div id="problem" style={S.section}>
        <h2 style={S.h2}>The Problem — Why This Matters!</h2>
        <p style={S.p}>
          The main problem is that menhaden have been fished heavily for industrial use for a very long time, and a large amount of that catch comes from the Chesapeake Bay, which is basically the most important nursery habitat for Atlantic menhaden.
        </p>
        <p style={S.p}>
          There is an industrial reduction fishery operating out of Reedville, Virginia on the northern Neck. They catch menhaden in huge purse seine nets and "reduce" them — meaning they cook and press the fish into oil and meal. This has been happening since the 1800s in various forms.
        </p>
        <p style={S.p}>
          Some numbers I found that I think are pretty striking:
        </p>
        <table style={S.table}>
          <thead>
            <tr>
              <th style={S.th}>Metric</th>
              <th style={S.th}>Number</th>
              <th style={S.th}>Source</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td style={S.td}>Approximate annual menhaden catch (U.S.)</td>
              <td style={S.td}>~3.4 billion fish</td>
              <td style={S.td}>ASMFC / NOAA data</td>
            </tr>
            <tr>
              <td style={S.tdAlt}>Percentage of products exported (estimated)</td>
              <td style={S.tdAlt}>~85%</td>
              <td style={S.tdAlt}>Trade analysis</td>
            </tr>
            <tr>
              <td style={S.td}>Approximate value per fish to processor</td>
              <td style={S.td}>~$0.075 (7.5 cents)</td>
              <td style={S.td}>Calculated from dockside value data</td>
            </tr>
            <tr>
              <td style={S.tdAlt}>Atlantic Menhaden 2023 coastwide harvest (lbs)</td>
              <td style={S.tdAlt}>~379 million lbs</td>
              <td style={S.tdAlt}>NOAA NMFS Fisheries Statistics</td>
            </tr>
            <tr>
              <td style={S.td}>Virginia reduction fishery share of total harvest</td>
              <td style={S.td}>~74%</td>
              <td style={S.td}>ASMFC Stock Assessment</td>
            </tr>
          </tbody>
        </table>
        <p style={S.p}>
          So basically — 3.4 billion fish, mostly caught in or near the Chesapeake Bay, mostly exported overseas, for about 7 and a half cents per fish. I found this really disturbing when I thought about it.
        </p>
        <p style={S.p}>
          A Washington Post article from November 2025 (Robichaux, 2025) described it this way: the reduction fishery removes enormous quantities of the fish that all the recreational and commercial species depend on, while delivering most of the economic benefit to foreign markets and industrial processors. I thought that was a pretty good summary.
        </p>
        <p style={S.p}>
          There is also a question of <strong>water quality</strong>. The Chesapeake Bay has serious problems with algal blooms and low oxygen "dead zones." Menhaden, as filter feeders, help with this. When you remove billions of filter feeders, the water quality problem gets worse. This is harder to prove scientifically but a lot of scientists think it is real.
        </p>

        {/* Placeholder chart */}
        <div style={S.placeholder}>
          CHART COMING SOON<br />
          <span style={{ fontSize: '0.85rem' }}>(I am still learning how to make charts — sorry!)</span>
        </div>
      </div>

      {/* Data I Found */}
      <div style={S.section}>
        <h2 style={S.h2}>Data I Found</h2>
        <p style={S.p}>
          Here is some catch data I pulled from NOAA records. I am not 100% sure I am reading these correctly, but this is my best effort. The numbers are in millions of pounds of fish landed:
        </p>
        <table style={S.table}>
          <thead>
            <tr>
              <th style={S.th}>Year</th>
              <th style={S.th}>Total Atlantic Landings (mil. lbs)</th>
              <th style={S.th}>Virginia Reduction (mil. lbs)</th>
              <th style={S.th}>Notes</th>
            </tr>
          </thead>
          <tbody>
            {[
              ['2015', '641', '493', ''],
              ['2016', '598', '452', ''],
              ['2017', '466', '337', 'First year of new ASMFC catch cap'],
              ['2018', '468', '339', ''],
              ['2019', '447', '325', ''],
              ['2020', '410', '289', 'COVID disruptions'],
              ['2021', '422', '301', ''],
              ['2022', '399', '287', ''],
              ['2023', '379', '275', 'Most recent data I found'],
            ].map(([yr, total, va, note], i) => (
              <tr key={yr}>
                <td style={i % 2 === 0 ? S.td : S.tdAlt}>{yr}</td>
                <td style={i % 2 === 0 ? S.td : S.tdAlt}>{total}</td>
                <td style={i % 2 === 0 ? S.td : S.tdAlt}>{va}</td>
                <td style={i % 2 === 0 ? S.td : S.tdAlt}>{note}</td>
              </tr>
            ))}
          </tbody>
        </table>
        <p style={{ ...S.p, fontStyle: 'italic', fontSize: '0.85rem' }}>
          Note: I am still learning how to make charts sorry. The table will have to do for now. I might add a chart later when I figure out how.
        </p>
      </div>

      {/* What Can We Do */}
      <div id="action" style={S.section}>
        <h2 style={S.h2}>What Can We Do?!</h2>
        <p style={S.p}>
          This is honestly the hardest part because it feels really complicated. But here are some things I have found:
        </p>
        <ul style={{ paddingLeft: '22px', color: '#555', fontSize: '0.97rem', lineHeight: '1.8', marginBottom: '12px' }}>
          <li><strong>Write your congressman or senator.</strong> The Atlantic States Marine Fisheries Commission (ASMFC) manages menhaden, but Congress oversees NOAA and funding. Your representatives can push for stronger conservation measures.</li>
          <li><strong>Contact ASMFC directly.</strong> The ASMFC has a public comment process. They actually do read comments from the public during stock assessments and management reviews. Website: <a href="https://www.asmfc.org" target="_blank" rel="noopener noreferrer" style={S.link}>www.asmfc.org</a></li>
          <li><strong>Support organizations working on this.</strong> Groups like the Chesapeake Bay Foundation and the Virginia Saltwater Sportfishing Association have been pushing for better menhaden management for years.</li>
          <li><strong>Spread the word.</strong> Most people have literally never heard of menhaden. Just telling people about this fish is useful.</li>
          <li><strong>Buy American-caught sustainable seafood</strong> and look for responsible sourcing of omega-3 supplements (some companies use plant-based or krill alternatives).</li>
        </ul>
        <p style={S.p}>
          I know this feels like small stuff. Honestly I am not sure individual action is enough. I think this requires real policy change. But I don't know enough about that yet to say much more.
        </p>
      </div>

      {/* Works Cited */}
      <div style={S.section}>
        <h2 style={S.h2}>Works Cited</h2>
        <ol style={S.citationsList}>
          <li style={{ marginBottom: '6px' }}>
            ASMFC (Atlantic States Marine Fisheries Commission). (2023). <em>Atlantic Menhaden Stock Assessment Update.</em> Retrieved from https://www.asmfc.org/species/atlantic-menhaden
          </li>
          <li style={{ marginBottom: '6px' }}>
            Franklin, H.B. (2007). <em>The Most Important Fish in the Sea: Menhaden and America.</em> Island Press/Shearwater Books.
          </li>
          <li style={{ marginBottom: '6px' }}>
            Jacquet, J., Pauly, D., et al. "Seafood Stewardship in Crisis." <em>Nature</em>, 467, 28–29 (2010). https://doi.org/10.1038/467028a
          </li>
          <li style={{ marginBottom: '6px' }}>
            NOAA NMFS. Fisheries Statistics — Atlantic Menhaden Landings. https://www.fisheries.noaa.gov/foss/f?p=215
          </li>
          <li style={{ marginBottom: '6px' }}>
            Robichaux, M. (November 20, 2025). "Virginia's menhaden industry ships most of its catch overseas. Critics say the Bay pays the price." <em>The Washington Post.</em>
          </li>
          <li style={{ marginBottom: '6px' }}>
            Smith, T.I.J. (1999). "Status of the Atlantic menhaden resource." <em>Proceedings of the Atlantic Menhaden Research Program.</em> NOAA Technical Memorandum.
          </li>
          <li style={{ marginBottom: '6px' }}>
            Virginia Marine Resources Commission (VMRC). Menhaden regulations and reports. https://mrc.virginia.gov/commercial_fishing/menhaden.shtm
          </li>
          <li style={{ marginBottom: '6px' }}>
            Chesapeake Bay Foundation. Menhaden resources and policy positions. www.cbf.org [accessed March 2026]
          </li>
        </ol>
      </div>

      {/* Contact */}
      <div id="contact" style={S.section}>
        <h2 style={S.h2}>Contact</h2>
        <p style={S.p}>
          You can reach me at <a href="mailto:cjmorgan@menhadenpolicy.com" style={{ color: '#2c5f8a' }}>cjmorgan@menhadenpolicy.com</a>. I also check the access request form below occasionally if you'd prefer to leave a message that way.
        </p>
      </div>

      {/* Footer */}
      <footer style={S.footer}>
        <p>This website was made as a personal project. Last updated: March 2026.</p>
        <p style={{ marginTop: '6px' }}>
          Information provided for educational purposes only. Not affiliated with any organization.
        </p>
        <p style={{ marginTop: '18px' }}>
          <Link to="/access" style={S.accessLink}>
            Researchers and policy professionals: request access to the full analysis database →
          </Link>
        </p>
      </footer>

    </div>
  )
}
